/* eslint-disable react-hooks/exhaustive-deps */
import { MutableRefObject, useEffect, useState } from "react"
import { getLandingContainer } from "../views/utils/getLandingContainer"


export function useInViewport( ref: MutableRefObject<null>, delayBottom: number = 80 ): boolean {
    const [inViewport, setIsInViewport] = useState<boolean>( false ) 
    const onscrollHandler = () => {
        try 
        { 
            const element = ref.current
            if(!!element){
                setIsInViewport( isInViewport( element, delayBottom ) )
            } 
        } 
        catch (e) 
        {            
            console.log(e)            
        }
    }

    useEffect(() => {  
        const container = getLandingContainer()
        container.addEventListener("scroll", onscrollHandler) 
        onscrollHandler() 
        return () => { 
            container.removeEventListener("scroll", onscrollHandler)
        } 
    }, [])
    
    return inViewport
}
 
export function isInViewport(el: Element, delayBottom: number = 80) {
    const rect = el.getBoundingClientRect();
    return rect.top <= (window.innerHeight || document.documentElement.clientHeight) - delayBottom
    
    // return (
    //     rect.top >= 0 &&
    //     rect.left >= 0 &&
    //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    //     rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    // );
}